import { gql } from "@apollo/client";
import { LicenseType } from "@src/types.generated";
import { useUseLicenseType_BillingAccountsQuery } from "./useLicenseType.generated";
import { useMemo } from "react";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";

export const useLicenseType = (): LicenseType | undefined => {
  const { userActionPermissions } = useActionPermissions();
  const { data: billingAccountsData } = useUseLicenseType_BillingAccountsQuery({
    skip: !userActionPermissions?.manageBilling,
  });
  return useMemo(() => {
    return billingAccountsData?.BillingAccounts.flatMap((x) =>
      x.subscriptions.map((y) => y.plan.licenseType),
    ).find((x) => x != null);
  }, [billingAccountsData]);
};

gql`
  query useLicenseType_BillingAccounts {
    BillingAccounts(input: {}) {
      id
      subscriptions {
        id
        plan {
          id
          licenseType
        }
      }
    }
  }
`;
